export function isEmptyString(value) {
  return (!value || 0 === value.length);
}

export function stringStartsWith(string, prefix) {
  return string.slice(0, prefix.length) == prefix;
}

/*! GetDevicePixelRatio | Author: Tyson Matanich, 2012 | License: MIT */
export function getDevicePixelRatio() {
  let ratio = 1;
  // To account for zoom, change to use deviceXDPI instead of systemXDPI
  if (window.screen.systemXDPI !== undefined && window.screen.logicalXDPI !== undefined && window.screen.systemXDPI > window.screen.logicalXDPI) {
    // Only allow for values &gt; 1
    ratio = window.screen.systemXDPI / window.screen.logicalXDPI;
  }
  else if (window.devicePixelRatio !== undefined) {
    ratio = window.devicePixelRatio;
  }
  return ratio;
}



// WEBPACK FOOTER //
// ./client/helper/utils.js